"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntermediateRecordConfigSchema = exports.artifactType = exports.nodeType = exports.UIConfigSchema = void 0;
const v4_1 = require("zod/v4");
exports.UIConfigSchema = v4_1.z.object({
    artifactSlug: v4_1.z.string().min(2).max(100),
    loanProductSlug: v4_1.z.string().min(2).max(100).optional(),
    creditFacilitySlug: v4_1.z.string().min(2).max(100).optional(),
    externalFilename: v4_1.z.string().optional(),
    configuration: v4_1.z.object({}).optional(),
});
exports.nodeType = 'db_node';
exports.artifactType = 'db_node';
exports.IntermediateRecordConfigSchema = v4_1.z.object({});
//# sourceMappingURL=types.js.map